import { CREATE_CDC_CARD_START } from "../../types";

export const create_card_category = (payload) => ({
  type: CREATE_CDC_CARD_START,
  payload,
});
